import {
  COUNTRY_FILTER,
  STATE_FILTER,
  STATUS_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    country_id: 1,
    state_id: 1,
    city_name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "city_masters",
    schema: schema,
    include: [
      {
        model: "country_masters",
        as: "country",
      },
      {
        model: "state_masters",
        as: "state",
      },
    ],
  };

  const navigatePage = { back: "/city-list" };

  const headerName = "City";

  const validationType = "CityCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "city_masters",
      initialPayload: {
        modelName: "city_masters",
        schema: schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "city_name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "city_masters",
    schema: schema,
    include: [
      {
        model: "country_masters",
        as: "country",
      },
      {
        model: "state_masters",
        as: "state",
      },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Country Name", value: "country.country_name" },
    { label: "State Name", value: "state.state_name" },
    { label: "City Name", value: "city_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/city-create",
    edit: "/city-create",
    view: "/city-view",
  };

  const searchfields = [
    "city_name",
    "country.country_name",
    "state.state_name",
  ];

  const headerName = "City";
  const endpoint = "/getRecords";
  const exportFileName = "CityData.xlsx";

  const filterConfig = [COUNTRY_FILTER, STATE_FILTER, STATUS_FILTER];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "city_masters",
  schema: schema,
  include: [
    { module: "country_masters", moduleAs: "country" },
    { module: "state_masters", moduleAs: "state" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
